import { useQuery } from "@tanstack/react-query";

import { SsoProviders, userAccountAjax } from "../../ajax/UserAccountAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";

const NO_PROVIDERS: SsoProviders = { google: null, microsoft: null, linkedIn: false, signup: null };

export function useSsoProviders(): SsoProviders {
  const { data } = useQuery({
    queryKey: ["auth", "sso-providers"],
    queryFn: async () => {
      const res = await userAccountAjax.getSsoProviders();
      return ErrorResponse.isErrorResponse(res) ? NO_PROVIDERS : res;
    },
  });

  return data ?? NO_PROVIDERS;
}
